import { TableColumnDefinition } from '../table/table-column-definition'

export const FlipHistoryTableColumnDefinitions: TableColumnDefinition[] = [
  {
    columnName: 'assessmentDate',
    columnWidth: '170px',
    columnTextAlign: 'left',
    header: 'Assessment Date',
    sortDisabled: true,
    columnType: 'string',
  },
  {
    columnName: 'age',
    columnWidth: '50px',
    columnTextAlign: 'left',
    header: 'Age (Months)',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'score',
    columnWidth: '80px',
    columnTextAlign: 'left',
    header: 'Score',
    sortDisabled: true,
    columnType: 'string',
  },
  {
    columnName: 'scoreRange',
    columnWidth: '130px',
    columnTextAlign: 'left',
    header: 'Score Range',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'dataEnteredBy',
    columnWidth: '110px',
    columnTextAlign: 'left',
    header: 'Date Entered By',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'notes',
    columnWidth: '200px',
    columnTextAlign: 'left',
    header: 'Notes',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'view',
    columnTextAlign: 'left',
    columnType: 'link',
    columnWidth: '70px',
    header: '',
    linkColor: 'primary',
    linkKind: 'icon',
    showIcon: true,
    sortDisabled: true,
    textAlign: 'left',
  },
]
